import { FirearmAssignmentServiceBase } from './firearm-assignment.service.base';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { appendSerialisedHttpParams, ENVIRONMENT, markAsBackgroundServiceCall } from '@scisys-uim/uim-common';
import { FirearmAssignment, FirearmAssignmentStorageType, FirearmAssignmentType } from 'assets-model';
import { Observable } from 'rxjs';


export interface FirearmAssignablePersonBaseData {
  personId?: string;
}

export interface StorageFirearmAssignablePersonData extends FirearmAssignablePersonBaseData {
  username?: string;
}

export interface IssueFirearmAssignablePersonData extends FirearmAssignablePersonBaseData {
  rangerId?: number;
}

export interface FirearmAssignablePersonData extends IssueFirearmAssignablePersonData, StorageFirearmAssignablePersonData {
}

export interface ReturnFirearmToStorageData {
  storageAssignee: StorageFirearmAssignablePersonData;
  locationId?: number;
  comments?: string;
}

export interface FirearmAssignmentCreationData {
  person: FirearmAssignablePersonData;
  locationId?: number;
  assetId: number;
  comments?: string;
  firearmAssignmentType: FirearmAssignmentType;
  storageType?: FirearmAssignmentStorageType;
  personalFirearmAssignment?: boolean;
}

export interface FirearmAssignmentApprovalData {
  firearmAssignmentId: number;
  approve: boolean;
  reason?: string;
}

export interface FirearmAssignmentCancellationData {
  firearmAssignmentId: number;
  reason?: string;
}

export interface FirearmAssignmentActivationData {
  firearmAssignmentId: number;
  notifyPolice: boolean;
  policeNotificationReason?: string;
  locationId?: number;
  gunDealerLocationId?: number;
}

export interface FirearmAssignmentAcknowledgeTokenData {
  jwt: string;
}

@Injectable({
  providedIn: 'root'
})
export class FirearmAssignmentService extends FirearmAssignmentServiceBase {
  constructor(http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(http, environment);
  }

  public createAssignment(item: FirearmAssignmentCreationData): Observable<FirearmAssignment> {
    return this.deserialise(this.http.put<FirearmAssignment>(this.getUrlBaseCreate(), item));
  }

  public buApproveAssignment(item: FirearmAssignmentApprovalData): Observable<FirearmAssignment> {
    return this.deserialise(this.http.post<FirearmAssignment>(this.serviceBaseUrl + '/buApproveAssignment', item));
  }

  public transferBuApproveAssignment(item: FirearmAssignmentApprovalData): Observable<FirearmAssignment> {
    return this.deserialise(this.http.post<FirearmAssignment>(this.serviceBaseUrl + '/transferBuApproveAssignment', item));
  }

  public leadApproveAssignment(item: FirearmAssignmentApprovalData): Observable<FirearmAssignment> {
    return this.deserialise(this.http.post<FirearmAssignment>(this.serviceBaseUrl + '/leadApproveAssignment', item));
  }

  public activateAssignment(item: FirearmAssignmentActivationData): Observable<FirearmAssignment> {
    return this.deserialise(this.http.post<FirearmAssignment>(this.serviceBaseUrl + '/activateAssignment', item));
  }

  public completeDisposalAssignment(firearmAssignmentId: number): Observable<FirearmAssignment> {
    return this.deserialise(this.http.post<FirearmAssignment>(this.serviceBaseUrl + '/completeDisposalAssignment/' + firearmAssignmentId, null));
  }

  public reissueStartToken(firearmAssignmentId: number): Observable<FirearmAssignment> {
    return this.deserialise(this.http.post<FirearmAssignment>(this.serviceBaseUrl + '/reissueStartToken/' + firearmAssignmentId, null));
  }

  public cancelAssignment(item: FirearmAssignmentCancellationData): Observable<FirearmAssignment> {
    return this.deserialise(this.http.post<FirearmAssignment>(this.serviceBaseUrl + '/cancelAssignment', item));
  }

  public startAssignment(firearmAssignmentId: number): Observable<FirearmAssignment> {
    return this.deserialise(this.http.post<FirearmAssignment>(this.serviceBaseUrl + '/startAssignment/' + firearmAssignmentId, null));
  }

  public acknowledgeAssignment(item: FirearmAssignmentAcknowledgeTokenData): Observable<void> {
    return this.http.post<void>(this.serviceBaseUrl + '/acknowledgeAssignment', item);
  }

  public resendPoliceNotification(firearmAssignmentId: number): Observable<FirearmAssignment> {
    return this.deserialise(this.http.post<FirearmAssignment>(this.serviceBaseUrl + '/resendPoliceNotification/' + firearmAssignmentId, null));
  }

  public exampleNotifyPoliceTemplateParameters(issue: boolean, backgroundServiceCall: boolean = true): Observable<{
    [key: string]: string
  }> {
    var params = appendSerialisedHttpParams(issue, 'issue');
    return this.http.get<{ [key: string]: string }>(this.serviceBaseUrl + '/exampleNotifyPoliceTemplateParameters', {
      params: params,
      headers: backgroundServiceCall ? markAsBackgroundServiceCall() : null
    });
  }
}
